import {isString, get, isFunction} from "lodash";
import {capitalizeFilter} from "@/utils/formatting";

export const mapStateProperty = (mappedProperties) => {
    const computedMethods = {};
    const resolvedProperties = isFunction(mappedProperties) ? mappedProperties() : mappedProperties;

    const normalizedProperties = [];
    resolvedProperties.forEach(pathOrObject => {
        if (isString(pathOrObject)) {
            const [object, path] = pathOrObject.split('.');
            normalizedProperties.push({name: path, path, object});
        } else {
            if (isFunction(pathOrObject.path)) {
                pathOrObject.path = pathOrObject.path();
            }
            let [object, ...path] = pathOrObject.path.split('.');
            path = path.join('.');
            normalizedProperties.push({name: pathOrObject.name, path, object});
        }
    });

    normalizedProperties.forEach(({name, path, object}) => {
        const action = 'set' + capitalizeFilter(object) + 'Property';
        computedMethods[name] = {
            get() {
                return get(this.$store.state[object], path);
            },
            set(value) {
                this.$store.dispatch(action, {property: path, value});
            }
        };
    });

    return computedMethods;
};